"use client";

import Heading from "@/component/ui/Heading";
import Image from "next/image";
import CityPriceDescriptionBlock from "./CityPriceDescriptionBlock";

type CityPriceDesktopTopContentProps = {
    topPriceHeading: string;
    reviewRating: number;
    reviewCount: number;
    model: any;
    variants: any[];
    cityName?: string;
};

function TopReviewMeta({ reviewRating, reviewCount }: { reviewRating: number; reviewCount: number }) {
    if (reviewRating <= 0 && reviewCount <= 0) return null;

    return (
        <div className="flex items-center gap-2 shrink-0 mb-3">
            {reviewRating > 0 && (
                <p className="text-[13px] leading-none">
                    <span className="font-bold text-black md:font-normal md:text-[#5F6B7A]">
                        {reviewRating.toFixed(1)}
                    </span>
                    <span className="font-normal text-[#5F6B7A]"> /</span>
                    <span className="text-[11px] font-normal text-[#5F6B7A]"> 5</span>
                </p>
            )}
            {reviewRating > 0 && (
                <Image
                    src="https://static-asset.tractorjunction.com/cj/yellow-star.svg"
                    alt="Rating"
                    title="Rating"
                    width={12}
                    height={12}
                    className="size-3"
                />
            )}
            {reviewCount > 0 && (
                <a href="#customer-reviews" className="text-[13px] font-normal text-[#155DFC] hover:underline">
                    {reviewCount} Reviews
                </a>
            )}
        </div>
    );
}

export default function CityPriceDesktopTopContent({
    topPriceHeading,
    reviewRating,
    reviewCount,
    model,
    variants,
    cityName,
}: CityPriceDesktopTopContentProps) {
    const hasReviews = reviewRating > 0 || reviewCount > 0;

    return (
        <>
            <div
                className={
                    hasReviews
                        ? "flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center md:gap-3 mb-3"
                        : "mb-3"
                }
            >
                <Heading tag="h1" className={`font-bold ${hasReviews ? "!mb-0" : "mb-3"}`}>
                    {topPriceHeading}
                </Heading>
                <TopReviewMeta reviewRating={reviewRating} reviewCount={reviewCount} />
            </div>
            <CityPriceDescriptionBlock model={model} variants={variants} cityName={cityName} />
        </>
    );
}
